/* ============================================================
   Lu's - Automatisch gratis Texture kam vanaf 50 euro

   REGELS
   1. Boven de 50 euro komt het cadeauproduct "Texture kam (cadeau)"
      (0,00) in de winkelwagen.
   2. Haalt de klant het cadeau er zelf uit, dan blijft het weg. Het komt pas
      weer terug als de winkelwagen onder de 50 euro zakt en er daarna weer
      boven komt (dan is het een nieuw aanbod).
   3. Zet de klant boven de 50 euro zelf een BETAALDE Texture kam (9,99) in de
      winkelwagen en is er nog geen cadeau, dan wordt die kam gratis: het
      cadeauproduct gaat erin en een betaalde kam gaat eraf. Wil de klant een
      tweede kam kopen, dan blijft die gewoon 9,99.
   4. Onder de 50 euro gaat het cadeau eruit en wordt alles gereset.

   DREMPEL = WAT DE KLANT ECHT BETAALT (na korting, excl. kammen)
   De drempel rekent met het bedrag NA korting: staffelkorting, productcodes
   en bestelcodes (bijv. via een /discount/CODE link uit een mail of een code
   in de winkelwagen). Zakt het bedrag door een code onder de 50 euro, dan gaat
   de kam eruit. Dit is gelijk aan de freegift-bar, die met cart.total_price
   rekent.
   Een code uit een /discount/CODE link staat alleen in een cookie; het script
   zet die code zelf op de winkelwagen zodat de korting hier al meetelt.
   LET OP: een code die pas in de CHECKOUT wordt ingetypt ziet dit script niet,
   want in de checkout draait geen themacode.

   WAAROM EEN CADEAUPRODUCT EN GEEN KORTING
   Een BxGy-korting kon niet samen met een productkorting, waardoor de
   staffelkorting (5% vanaf 2 stuks / 10% vanaf 3 stuks) verviel zodra de
   gratis kam in de winkelwagen kwam. Met een cadeauproduct van 0,00 werken de
   staffelkorting en de gratis kam altijd allebei.

   OVERGANGSSITUATIE (stap D)
   Zolang de oude automatische korting "Gratis Texture kam vanaf 50" in de
   admin nog aan staat, zet die korting een betaalde kam zelf al op 0,00.
   Staat er dan een cadeau EN zo'n gratis gemaakte betaalde kam, dan zou de
   klant twee gratis kammen hebben. Het script haalt in dat geval de betaalde
   regel weg en laat het cadeau staan.

   GEHEUGEN
   De status staat in localStorage onder twee vaste sleutels. Bewust niet op
   winkelwagen-token: dat token is in Liquid anders dan in /cart.js, waardoor
   de status bij elke paginawissel kwijtraakte. Resetten gebeurt op de inhoud
   van de winkelwagen: zakt die onder de 50 euro (en dus ook bij een lege
   winkelwagen na een bestelling), dan is het geheugen leeg.

   Werkt op de CartJS-cart van het Bullet-thema.
   ============================================================ */
(function () {
  "use strict";

  var GIFT_VARIANT_ID = 56212422361473; // Texture kam (cadeau) - 0,00
  var PAID_VARIANT_ID = 55758021296513; // Texture kam - 9,99
  var THRESHOLD_CENTS = 5000;           // 50,00 - gelijk aan de freegift-bar (data-gift)
  var GIFT_PROP = "_gratis";
  var GIFT_VAL  = "ja";
  var MAX_ACTIONS = 30;                 // noodrem tegen doorlopen bij een fout

  var KEY_OFFERED  = "lus_kam_aangeboden";
  var KEY_DECLINED = "lus_kam_geweigerd";

  var busy = false;            // voorkomt overlappende cart-verzoeken
  var resyncAfter = false;     // forceert 1x een verse /cart.js na een wijziging
  var selfRemovedGift = false; // het script haalde het cadeau weg, niet de klant
  var pendingConvert = false;  // cadeau toegevoegd, betaalde kam moet er nog af
  var actions = 0;

  /* ---------- geheugen ---------------------------------------------------- */
  function getFlag(key) {
    try { return window.localStorage.getItem(key) === "ja"; }
    catch (e) { return false; }
  }
  function setFlag(key, on) {
    try {
      if (on) window.localStorage.setItem(key, "ja");
      else window.localStorage.removeItem(key);
    } catch (e) {}
  }
  /* Sleutels uit een oudere versie (met winkelwagen-token) opruimen. */
  (function cleanup() {
    try {
      var doomed = [];
      for (var i = 0; i < window.localStorage.length; i++) {
        var k = window.localStorage.key(i);
        if (k && k.indexOf("lus_kam_") === 0 && k !== KEY_OFFERED && k !== KEY_DECLINED) doomed.push(k);
      }
      for (var j = 0; j < doomed.length; j++) window.localStorage.removeItem(doomed[j]);
    } catch (e) {}
  })();

  /* ---------- hulpjes ---------------------------------------------------- */
  function isAnyComb(it) {
    var id = Number(it.id);
    return id === GIFT_VARIANT_ID || id === PAID_VARIANT_ID;
  }
  function isGift(it) { return Number(it.id) === GIFT_VARIANT_ID; }
  function isPaid(it) { return Number(it.id) === PAID_VARIANT_ID; }

  /* Krijgt deze regel korting? Op de betaalde kam kan dat alleen van de oude
     automatische korting komen; de staffelkorting geldt niet voor kammen. */
  function hasDiscount(it) {
    if (Number(it.total_discount) > 0) return true;
    var allocs = it.line_level_discount_allocations || it.discounts || [];
    for (var i = 0; i < allocs.length; i++) {
      var a = allocs[i];
      if (a && a.amount != null && Number(a.amount) > 0) return true;
    }
    return false;
  }

  /* Regelprijs NA regelkorting (staffel, productcodes). */
  function finalLine(it) {
    if (it.final_line_price != null) return Number(it.final_line_price) || 0;
    if (it.line_price != null) return Number(it.line_price) || 0;
    return Number(it.original_line_price) || 0;
  }

  /* Totaal aan bestelkorting (codes op de hele bestelling), in centen. */
  function orderDiscount(cart, allFinal) {
    var total = 0;
    var apps = (cart && cart.cart_level_discount_applications) || [];
    for (var i = 0; i < apps.length; i++) {
      var amt = apps[i] && Number(apps[i].total_allocated_amount);
      if (amt > 0) total += amt;
    }
    /* Vangnet: total_price is altijd na bestelkorting. */
    if (total === 0 && cart && cart.total_price != null) {
      var diff = allFinal - Number(cart.total_price);
      if (diff > 0) total = diff;
    }
    return total;
  }

  /* Drempelbedrag: wat de klant echt betaalt voor alles BEHALVE de kammen.
     Bestelkorting wordt naar rato over de regels verdeeld, net als Shopify. */
  function eligibleSubtotal(cart) {
    var items = (cart && cart.items) || [];
    var nonComb = 0, all = 0;
    for (var i = 0; i < items.length; i++) {
      var p = finalLine(items[i]);
      all += p;
      if (!isAnyComb(items[i])) nonComb += p;
    }
    if (all <= 0) return 0;
    var share = orderDiscount(cart, all) * (nonComb / all);
    var result = Math.round(nonComb - share);
    return result > 0 ? result : 0;
  }

  function linesOf(cart, test) {
    var items = (cart && cart.items) || [];
    var out = [];
    for (var i = 0; i < items.length; i++) {
      if (test(items[i])) out.push({ line: i + 1, item: items[i] });
    }
    return out;
  }

  function start() { busy = true; resyncAfter = true; actions++; }
  function addGift() {
    var props = {}; props[GIFT_PROP] = GIFT_VAL;
    if (typeof CartJS.addItem === "function") CartJS.addItem(GIFT_VARIANT_ID, 1, props);
  }
  function removeLine(line) {
    if (line > 0 && typeof CartJS.removeItem === "function") CartJS.removeItem(line);
  }
  function setLineToOne(line) {
    var props = {}; props[GIFT_PROP] = GIFT_VAL;
    if (line > 0 && typeof CartJS.updateItem === "function") CartJS.updateItem(line, 1, props);
  }
  function decrement(entry) {
    if (entry.item.quantity > 1 && typeof CartJS.updateItem === "function") {
      CartJS.updateItem(entry.line, entry.item.quantity - 1);
    } else {
      removeLine(entry.line);
    }
  }

  /* ---------- kortingscode uit een link ------------------------------------ */
  /* Een /discount/CODE link zet de code alleen in een cookie. De winkelwagen
     weet er dan nog niets van en ziet de korting pas in de checkout. Daarom
     zetten we die code zelf op de winkelwagen (/cart/update.js, discount),
     zodat de drempel met het echte bedrag rekent. Een keer per code per sessie. */
  var codeState = "open"; // open | busy | done

  function readCookie(name) {
    try {
      var m = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return m ? decodeURIComponent(m[1]).replace(/\+/g, " ") : "";
    } catch (e) { return ""; }
  }
  function triedCode(code, mark) {
    try {
      var k = "lus_code_geprobeerd_" + code.toLowerCase();
      if (mark) { window.sessionStorage.setItem(k, "ja"); return true; }
      return window.sessionStorage.getItem(k) === "ja";
    } catch (e) { return false; }
  }
  /* Geeft true terug als er een verzoek loopt; evaluate wacht dan. */
  function ensureCode(cart) {
    if (codeState !== "open") return codeState === "busy";
    if (!cart.items || cart.items.length === 0) return false; // later opnieuw
    var code = readCookie("discount_code");
    if (!code || !window.fetch) { codeState = "done"; return false; }

    var codes = cart.discount_codes || [];
    var keep = [];
    for (var i = 0; i < codes.length; i++) {
      var c = codes[i] && codes[i].code;
      if (!c) continue;
      if (String(c).toLowerCase() === code.toLowerCase()) { codeState = "done"; return false; }
      if (codes[i].applicable !== false) keep.push(c);
    }
    if (triedCode(code, false)) { codeState = "done"; return false; }

    codeState = "busy";
    triedCode(code, true);
    keep.push(code);
    var finish = function () {
      codeState = "done";
      if (window.CartJS && typeof CartJS.getCart === "function") CartJS.getCart();
    };
    window.fetch("/cart/update.js", {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ discount: keep.join(",") })
    }).then(finish, finish);
    return true;
  }

  /* ---------- kern ------------------------------------------------------- */
  function evaluate(cart) {
    if (busy) return;
    if (!window.CartJS || !cart || !cart.items) return;
    if (actions > MAX_ACTIONS) return;
    if (ensureCode(cart)) return; // wacht tot de code op de winkelwagen staat

    var sub = eligibleSubtotal(cart);
    var gifts = linesOf(cart, isGift);
    var paid = linesOf(cart, isPaid);

    /* A. Onder de drempel: cadeau eruit, geheugen leeg. Een volgende keer boven
          de 50 euro is een nieuw aanbod. */
    if (sub < THRESHOLD_CENTS) {
      pendingConvert = false;
      setFlag(KEY_OFFERED, false);
      setFlag(KEY_DECLINED, false);
      if (gifts.length > 0) { start(); selfRemovedGift = true; removeLine(gifts[0].line); }
      return;
    }

    /* B. Tweede stap van de omzetting: het cadeau staat er, nu de betaalde kam
          eraf. Eerst toevoegen en dan pas weghalen, zodat de klant nooit even
          zonder kam zit als er iets misgaat. */
    if (pendingConvert) {
      pendingConvert = false;
      if (gifts.length > 0 && paid.length > 0) { start(); decrement(paid[0]); return; }
    }

    /* C. Eerste stap van de omzetting: betaalde kam zonder cadeau -> gratis. */
    if (gifts.length === 0 && paid.length > 0) {
      setFlag(KEY_DECLINED, false);
      pendingConvert = true;
      start(); addGift();
      return;
    }

    /* D. Overgangssituatie: cadeau en een betaalde kam die door de oude korting
          al gratis is. Die betaalde regel eruit, nooit twee gratis kammen. */
    if (gifts.length > 0) {
      for (var d = 0; d < paid.length; d++) {
        if (hasDiscount(paid[d].item)) { start(); decrement(paid[d]); return; }
      }
    }

    /* E. Heeft de klant het cadeau zelf weggehaald? */
    if (gifts.length === 0 && getFlag(KEY_OFFERED)) {
      if (selfRemovedGift) selfRemovedGift = false;
      else setFlag(KEY_DECLINED, true);
      setFlag(KEY_OFFERED, false);
    }
    if (gifts.length > 0) selfRemovedGift = false;

    /* F. Normale situatie: precies een cadeau, tenzij de klant hem weghaalde. */
    if (gifts.length === 0) {
      if (!getFlag(KEY_DECLINED)) { start(); addGift(); }
      return;
    }
    if (gifts.length > 1) { start(); selfRemovedGift = true; removeLine(gifts[gifts.length - 1].line); return; }
    if (gifts[0].item.quantity > 1) { start(); setLineToOne(gifts[0].line); return; }

    setFlag(KEY_OFFERED, true);
  }

  function onComplete(e, cart) {
    busy = false;
    var c = cart || (window.CartJS && CartJS.cart);
    if (resyncAfter) {
      resyncAfter = false;
      if (window.CartJS && typeof CartJS.getCart === "function") { CartJS.getCart(); return; }
    }
    evaluate(c);
  }

  function bind() {
    if (!window.jQuery || !window.CartJS) return false;
    var $ = window.jQuery;
    $(document).on("cart.ready", function (e, cart) { busy = false; resyncAfter = false; evaluate(cart || CartJS.cart); });
    $(document).on("cart.requestComplete", onComplete);
    if (CartJS.cart) evaluate(CartJS.cart);
    return true;
  }

  function boot(tries) {
    if (bind()) return;
    if (tries <= 0) return;
    setTimeout(function () { boot(tries - 1); }, 200);
  }

  if (document.readyState !== "loading") boot(60);
  else document.addEventListener("DOMContentLoaded", function () { boot(60); });
})();
